/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AdminActivityTableActivityDto } from './adminActivityTableActivityDto';
import { AdminActivityTableScheduleDto } from './adminActivityTableScheduleDto';
import { AdminGroupListSportDto } from './adminGroupListSportDto';
import { AdminActivityTableGroupDto } from './adminActivityTableGroupDto';


export interface AdminActivityTableItemDto { 
    id: string;
    activity: AdminActivityTableActivityDto;
    group: AdminActivityTableGroupDto;
    schedule: AdminActivityTableScheduleDto;
    sport: AdminGroupListSportDto;
    status: AdminActivityTableItemDto.StatusEnum;
    participantsCount: number;
    /**
     * Event pricing type.
     */
    type?: string;
    /**
     * Human-readable activity location name.
     */
    locationName?: string;
}
export namespace AdminActivityTableItemDto {
    export type StatusEnum = 'scheduled' | 'finished' | 'cancelled';
    export const StatusEnum = {
        Scheduled: 'scheduled' as StatusEnum,
        Finished: 'finished' as StatusEnum,
        Cancelled: 'cancelled' as StatusEnum
    };
}


